import React, { useState, useEffect, useCallback, useRef, useMemo } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
//import { GoogleMap, Marker, InfoWindow, Polyline, LoadScript, LoadScriptNext, StreetViewPanorama, DirectionsService, DirectionsRenderer } from "@react-google-maps/api";
import "./esplorazione.css";
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import { Translator } from './translator';

const BASE = "https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com";
const MEDIA_BASE = "https://d2birz093jmopq.cloudfront.net";


const Esplorazione = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [tourID, dayIndexStr] = id.split("&");
  const selectedDayIndex = parseInt(dayIndexStr);   // this is 1-based
  const nextDayIndex = selectedDayIndex + 1;
  const prevDayIndex = selectedDayIndex - 1;
  const [tappaAudioUrl, setTappaAudioUrl] = useState(null);

//  const [openDay, setOpenDay] = useState(null); // To track the currently open day

  const decodeHtmlEntities = (text) => { const textarea = document.createElement("textarea"); textarea.innerHTML = text; return textarea.value; };
  const parseBoldText = (text) => {
    return text.split(/(<strong>.*?<\/strong>)/g).map((chunk, i) => {
      if (chunk.startsWith("<strong>") && chunk.endsWith("</strong>")) {
        return (
          <span key={i} style={{ color: "#ff4500", fontWeight: "bold" }}>
            {chunk.replace(/<\/?strong>/g, "")}
          </span>
        );
      }
      return chunk;
    });
  };

  const getIconSize = () => {
  const screenWidth = window.innerWidth;
  if (screenWidth < 768) return { width: 20, height: 28 }; // Mobile
  if (screenWidth < 1200) return { width: 25, height: 34 }; // Tablet
  return { width: 30, height: 41 }; // Desktop
};



  const [tourInfo, setTourInfo] = useState({ Firstsite: "", Lastsite: "",  Duration: "", days: [] });
  const [tour, setTour] = useState({ name: "", details: [] });
  //const [coords, setCoords] = useState([]);
  //const [popupInfo, setPopupInfo] = useState(null);
  
  
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [tappaimage, setImages] = useState([]);
  const [startingAddress, setStartingAddress] = useState("");
  const [openApprofondimento, setOpenApprofondimento] = useState(null);
  const [isVideoOpen, setIsVideoOpen] = useState(false);
  const [isVideoAvailable, setIsVideoAvailable] = useState(true);
  const [approfondimenti, setApprofondimenti] = useState([]);
  const [approfondimentoIndexByTappa, setApprofondimentoIndexByTappa] = useState({});
  //const [routePath, setRoutePath] = useState([]);
  //const [directionsResult, setDirectionsResult] = useState(null);
  //const [directionsRequest, setDirectionsRequest] = useState(null);
  //const mapRef = useRef(null);
  //const miniMapRefs = useRef({});
  //const hasFitBounds = useRef(false);
  //const [showRoute, setShowRoute] = useState(false);
  //const initialMapCenter = { lat: 40.8518, lng: 14.2681 }; // Naples
  //const [destination, setDestination] = useState(null);
  //const [userLocation, setUserLocation] = useState(null);
  const { translateText, lang } = Translator();
  const [ttsAudioUrl, setTtsAudioUrl] = useState(null);
  const [isSpeaking, setIsSpeaking] = useState(false);
  const globalAudioRef = useRef(null);
  //const [nearbyPlaces, setNearbyPlaces] = useState([]);
  //const [showAttractions, setShowAttractions] = useState(false);
  const [TappaData, setTappaData] = useState({});
  const [currentImg, setCurrentImg] = useState(0);
  const [approfondimentiAudio, setApprofondimentiAudio] = useState({});
  //const directionsPanelRef = useRef(null);
  const [totalDays, setTotalDays] = useState(0);


  const baseText = {
    text1: "Tour Esplorazione",
    text2: "Approfondimenti",
    text3: "Esplorazione ",
  
 
    text4: "All'esplorazione ",
    text5: "All'esplorazione ",
    text6: "➔",
    text34: "Scopri altri tour",

    text7: "Approfondimento ",
    text7_1: "La mia posizione",
    text7_2: "Seleziona la posizione di partenza",
    text7_3: "Seleziona la posizione di destinazione",
    text8: "Nessun titolo",
    text9: "Preparando il tuo tour...",
    text10: "Errore: ",
    text11: "Non sono disponibili dettagli sul tour.",
    text12: "Me",
    text13: "Nascondi percorso",
    text14: "Mostra il percorso consigliato",
    text15: "Caricamento mappa...",
    text16: "Il tuo browser non supporta la riproduzione video.",
    text17: "Caricamento audio...",
    text18: "Ascolta la descrizione",
    text19: "Approfondimento dell’esplorazione corrente",
    text23: "Guarda video",
    text25: "Impossibile ottenere la posizione attuale.",
    text26: "Ottieni indicazioni stradali",
    text27: "Nessuna sottotitolo disponibile",
    text28: "Nessuna descrizione disponibile",
    text29: "Nessun audio disponibile",
    text30: "Giornata Consigliata:",
    text31: "Nascondi i musei vicini",
    text32: "Mostra i musei vicini",
    text33: "Descrizione:",
   
  };

  // For text22 counter 
  const getTranslated = (key, vars = {}) => {
    let template = translatedText[key] || "";
    Object.entries(vars).forEach(([k, v]) => {
      template = template.replace(`{${k}}`, v);
    });
    return template;
  };

// Translate base text from Italian to the selected language
  const [translatedText, setTranslatedText] = useState(baseText);
  useEffect(() => {
    const translateAll = async () => {
      const entries = Object.entries(baseText);
      const translatedEntries = await Promise.all(
        entries.map(async ([key, value]) => [key, await translateText(value)])
      );
      setTranslatedText(Object.fromEntries(translatedEntries));
    };

    translateAll();
  }, [lang]);


  const approfondimentiForCurrentDay = useMemo(
    () => approfondimenti.filter(a => a.tappa === selectedDayIndex),
    [approfondimenti, selectedDayIndex]
  );
  const approfCount = approfondimentiForCurrentDay.length;

  const toMediaUrl = (p) => {
    if (!p) return null;
    const s = String(p).trim();
    if (/^https?:\/\//i.test(s)) return s; // already absolute
    const cleaned = s.replace(/^\/+/, "").replace(/^media\//i, "");
    return `${MEDIA_BASE}/media/${cleaned}`;
  };




  // -------------------------------
  //  Extract Approfondimenti Subheadings
  // -------------------------------
  const approfSubs = useMemo(() => {
    const day = selectedDayIndex;
    if (!TappaData || !day) return [];
    const rx = new RegExp(`^it_tappa${day}SubheadingAPPROFONDIMENTO(\\d+)$`, "i");
    const pairs = Object.entries(TappaData)
      .map(([k, v]) => {
        const m = rx.exec(k);
        return m && v ? [parseInt(m[1], 10), String(v)] : null;
      })
      .filter(Boolean)
      .sort((a, b) => a[0] - b[0]);
    return pairs.map(([, text]) => text);
  }, [TappaData, selectedDayIndex]);




  // To handle suggesting going to next tappa
  const handleNextEsplorazione = () => {
    if (selectedDayIndex >= totalDays) return;
    navigate(`/esplorazione/${tourID}&${nextDayIndex}`);
  };

  // To handle suggesting going to previous tappa
  const handlePrevEsplorazione = () => {
    navigate(`/esplorazione/${tourID}&${prevDayIndex}`);
  };
  
  // To handle suggesting another tours
  const handleGoToChoose = () => {
    navigate("/choose");
  };



  // -----------------------------
  //  Auto-open first approfondimento for the tour
  // -----------------------------
  useEffect(() => {
    const itemsForDay = approfondimenti.filter(a => a.tappa === selectedDayIndex);
    if (itemsForDay.length > 0) {
          const key = `${selectedDayIndex}-0`;
      setOpenApprofondimento(key);
      ensureApprofondimentoAudio(selectedDayIndex, 0);
    } else {
      setOpenApprofondimento(null);
    }
  }, [approfondimenti, selectedDayIndex]);



  const handleNextApprofondimento = (tappaIndex) => {
    const items = approfondimenti.filter((a) => a.tappa === tappaIndex + 1);
    if (!items.length) return;
  
    setApprofondimentoIndexByTappa((prev) => {
      const current = prev[tappaIndex] || 0;
      const next = (current + 1) % items.length;
      return { ...prev, [tappaIndex]: next };
    });
  };



  // -----------------------------
  //  Fetch Polly TTS
  // -----------------------------
  const speakWithPolly = async (text, { setGlobal = false } = {}) => {
  try {
    if (setGlobal) setIsSpeaking(true);
    const body = new URLSearchParams({ text, lang });

    const res = await fetch(
      "https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/speak",
      {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString(),
      }
    );

    const audioUrl = await res.text();

    // Only update the global tappa player when explicitly requested
    if (setGlobal) setTtsAudioUrl(audioUrl);

    return audioUrl; // Always return the URL for local/per-item use
  } catch (err) {
    console.error("TTS failed:", err);
    if (setGlobal) setTtsAudioUrl(null);
    return null;
  } finally {
    if (setGlobal) setIsSpeaking(false);
  }
};


  useEffect(() => {
    setTtsAudioUrl(null);  // Reset audio on language change
  }, [lang]);


  useEffect(() => {
    // If you have a pre-recorded file for this tappa, don't hit Polly
    if (tappaAudioUrl) return;
    if (tour.tappaDescrizione) {
      // Important: setGlobal=true so only THIS place controls the big player
      speakWithPolly(tour.tappaDescrizione, { setGlobal: true });
    }
  }, [tour.tappaDescrizione, lang, tappaAudioUrl]);






  const ensureApprofondimentoAudio = async (tappaNum, idx) => {
    const key = `${tappaNum}-${idx}`;
    if (approfondimentiAudio[key]) return;

    // 1) Try the file from tour data
    const audioProp = `it_tappa${tappaNum}APPROFONDIMENTO${idx + 1}_audio`;
    const filePath = TappaData?.[audioProp];
    if (filePath) {
      setApprofondimentiAudio(prev => ({ ...prev, [key]: toMediaUrl(filePath) }));
      return;
    }

    // 2) Fallback to Polly
    const itemsForDay = approfondimenti.filter(a => a.tappa === tappaNum);
    const item = itemsForDay?.[idx];
    if (item?.description) {
      const url = await speakWithPolly(tour.tappaDescrizione);
      if (url) setApprofondimentiAudio(prev => ({ ...prev, [key]: url }));
    }
  };




    


  

/*
  // -----------------------------
  //  Fetch Images
  // -----------------------------
  const fetchTourMedia = useCallback(async () => {
    try {
      const { data } = await axios.get(`https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/collectPics?tourID=${tourID}`);
      
        if (data.img && Array.isArray(data.img)) {
          const formattedMedia = data.img.map(file => `https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/media/${encodeURIComponent(file)}`);
        setImages(formattedMedia);
        }
    } catch (error) {
        console.error("Error fetching tour media:", error);
    }
}, [tourID]);
*/


useEffect(() => {
  const fetchApprofondimenti = async () => {
    try {
      const { data } = await axios.get(`https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/getTecheAPPROFONDIMENTODesc?tourID=${tourID}&lang=${lang}`);
      setApprofondimenti(data);
    } catch (error) {
      console.error("Error fetching approfondimenti:", error);
    }
  };

  fetchApprofondimenti();
}, [tourID, lang]);





// --------------------------------------------------------------
//  Audio Players - Prevent multiple audios from playing at once
// --------------------------------------------------------------
const handlePlay = (audioElement) => {
  if (globalAudioRef.current && globalAudioRef.current !== audioElement) {
    globalAudioRef.current.pause();
  }
  globalAudioRef.current = audioElement;
};










/*
useEffect(() => {
  if (!startingAddress || !destination) return;

  if (
    startingAddress.lat === destination.lat &&
    startingAddress.lng === destination.lng
  ) {
    console.warn("Start and end points are the same. Skipping directions.");
    return;
  }

  // ✅ CLEAR panel before new request
  const panelEl = document.getElementById("directionsPanel");
  if (panelEl) panelEl.innerHTML = "";

  const request = {
    origin: startingAddress,
    destination: destination,
    travelMode: "DRIVING"
  };

  setDirectionsResult(null);         // Clear previous result
  setDirectionsRequest(request);     // Triggers new DirectionsService
  setShowRoute(true);                // Ensure UI is visible
}, [startingAddress, destination]);








useEffect(() => {
  if (!navigator.geolocation) {
    console.warn("Geolocation not supported");
    return;
  }
  navigator.geolocation.getCurrentPosition(
    ({ coords }) => {
      setUserLocation({
        lat: coords.latitude,
        lng: coords.longitude
      });
    },
    (err) => {
      console.warn("Could not get user location", err);
    }
  );
}, []);
*/







useEffect(() => {
  const fetchTourData = async () => {
    try {
      setLoading(true);

      // CLEAR previous content before loading new one
      setTourInfo({ Firstsite: "", Lastsite: "", Duration: "", days: [] });
      setTour({ name: "", details: [], tappaDescrizione: "", subheading: "", image: null });
      /*setCoords([]);
      setPopupInfo(null);
      setRoutePath([]);
      setDirectionsResult(null);
      setDirectionsRequest(null);
   */   setImages([]);

      //To count views for the tour
      axios.get(`https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/addTourViews?tourID=${tourID}`).catch(() => {});

      const [
        tourResponse,
        giornoDescResponse,
        giornoTappeResponse
      ] = await Promise.all([
        axios.get(`https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/getTecheTourByIDNew?nodeID=${tourID}&lang=${lang}`),
        axios.get(`https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/getTecheTappaDescNew?tourID=${tourID}&lang=${lang}`),
        axios.get(`https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/getGiornoTappe?tourID=${tourID}`),
      ]);

      const tourData = tourResponse.data.tour;
      const giornoDescData = giornoDescResponse.data;
      const tourDetails = Array.isArray(giornoTappeResponse.data) ? giornoTappeResponse.data : [];

      setTappaData(tourData);
      
      const tappaAudioKey = `it_AudioTappa${selectedDayIndex}`;
      setTappaAudioUrl(tourData[tappaAudioKey] ? toMediaUrl(tourData[tappaAudioKey]) : null);
      
      // ✅ Parse and set images for current tappa from imggiornoX
      const giornoKey = `imggiorno${selectedDayIndex}`;
      if (tourData[giornoKey]) {
        try {
          const parsedImages = JSON.parse(tourData[giornoKey]);
          setImages(parsedImages.map((path) => toMediaUrl(path)));
        } catch (e) {
          console.error("Invalid JSON in imggiorno:", e);
        }
      }

      // ✅ Set tourInfo
      setTourInfo({
        Firstsite: tourData.Firstsite,
        Lastsite: tourData.Lastsite,
        Duration: tourData.duration || "N/A",
        days: Array.isArray(giornoDescData) ? giornoDescData.map((day, index) => ({
            title: day.intestazione || `Tappa ${index + 1}`,
            tappaname: day.tappaname || `Tappa ${index + 1}`,
            tappaSubtitle: day.tappaSubtitle || translatedText.text27,
            description: day.desc || translatedText.text28,
            tappaGPS: day.tappaGPS || "40.8358846,14.2487679",
            tappeAudio: tourData[`it_AudioTappa${index + 1}`] || translatedText.text29,
            tappaimage: day.img ? JSON.parse(day.img) : [],
        })) : []
      });

      // To set how many tappe in this tour
      setTotalDays(Array.isArray(giornoDescData) ? giornoDescData.length : 0);

      // ✅ Set main tour data
      setTour({
        name: tourData.Name_it || "Teche Tour",
        subheading: tourData.Subheading_it || "Teche Tour",
        tappaDescrizione: tourData[`it_tappadescription${selectedDayIndex}`] || "Nessuna descrizione della tappa",        //Tappa
        details: tourDetails,
        //image: tourData.Image ? `https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/media/${tourData.Image}` : null,
        image: tourData.Image ? toMediaUrl(tourData.Image) : null,

      });

      // ✅ Then fetch coords
//      await fetchCoordinates(tourDetails, tourData);
    } catch (err) {
      console.error("Error fetching combined tour data:", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  fetchTourData();
}, [tourID, lang, selectedDayIndex]);







  // -----------------------------
  //  Fetch Tour views
  // -----------------------------
  useEffect(() => {
  const incrementViews = async () => {
    try {
      await axios.get(`https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/addTourViews?tourID=${tourID}`);
    } catch (err) {
      console.error("Failed to update views", err);
    }
  };

  incrementViews();
}, [tourID]);





// -----------------------------
//  Fetch Approfondimenti Audio
// -----------------------------
useEffect(() => {
  // If nothing is open or it's already loaded, do nothing
  if (!openApprofondimento || approfondimentiAudio[openApprofondimento]) return;

  // Key format is "<tappa>-<idx>" e.g., "3-0"
  const [tappaStr, idxStr] = openApprofondimento.split("-");
  const currentTappaNum = Number(tappaStr);
  const idxNum = Number(idxStr);

  // 1) Try backend file: it_tappa{N}APPROFONDIMENTO{idx+1}_audio
  const audioProp = `it_tappa${currentTappaNum}APPROFONDIMENTO${idxNum + 1}_audio`;
  const filePath = TappaData?.[audioProp];

  if (filePath) {
    setApprofondimentiAudio(prev => ({
      ...prev,
      [openApprofondimento]: toMediaUrl(filePath),
    }));
    return;
  }

  // 2) Fallback to Polly if no file exists
  const itemsForDay = approfondimenti.filter(a => a.tappa === currentTappaNum);
  const item = itemsForDay?.[idxNum];
  if (item?.description) {
    (async () => {
      const url = await speakWithPolly(item.description);
      if (url) {
        setApprofondimentiAudio(prev => ({
          ...prev,
          [openApprofondimento]: url,
        }));
      }
    })();
  }
}, [openApprofondimento, TappaData, approfondimenti, speakWithPolly, setApprofondimentiAudio]);



  // -----------------------------
  //  Fetch Coordinates
  // -----------------------------
const fetchCoordinates = async (tourDetails, tourData) => {
  try {
    const gpsCoordsList = Object.entries(tourData)
      .filter(([key]) => key.startsWith("tappaGPS"))
      .sort(([a], [b]) => {
        const numA = parseInt(a.replace("tappaGPS", ""));
        const numB = parseInt(b.replace("tappaGPS", ""));
        return numA - numB;
      });

    const enrichedCoords = await Promise.all(
      gpsCoordsList.map(async ([key, value], index) => {
        const [lat, lon] = value.split(",").map(Number);
        const day = index + 1;

        const tappeID = tourDetails?.[index]?.tappe?.[0]; // First tappa for that day
        if (!tappeID) return null;

        try {
          const { data: detailData } = await axios.get(`https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/getTappaTextNew?TappaID=${tappeID}&lang=${lang}`);
          const details = Array.isArray(detailData) ? detailData[0] : {};

          return {
            id: tappeID,
            lat,
            lon,
            day,
            name: tourData[`it_tappaname${day}`] || `Tappa ${day}`,
            description: tourData[`it_Subheadingtappa${day}`] || "",
            text: details?.Text || "",
            image: details?.Immagine ? `https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/media/${details.Immagine}` : null,
          };
        } catch (err) {
          console.error(`Error fetching site info for ID ${tappeID}`, err);
          
        }
      })
    );
/*
    const validCoords = enrichedCoords.filter(Boolean);
    setCoords(validCoords);

    if (validCoords.length > 0) {
      fetchNearbyPlaces({ lat: validCoords[0].lat, lng: validCoords[0].lon }, "museum");
    }

    const pathArray = validCoords.map(({ lat, lon }) => ({ lat, lng: lon }));
    setRoutePath(pathArray);

    if (validCoords.length) {
      const avgLat = validCoords.reduce((sum, c) => sum + c.lat, 0) / validCoords.length;
      const avgLng = validCoords.reduce((sum, c) => sum + c.lon, 0) / validCoords.length;
    }
  */  
  } catch (error) {
    console.error("Error fetching coordinates:", error);
  }
};

  
  
  


/*
// Function to Fetch Nearby Places (We may change it from museums to tourist_attraction)
const fetchNearbyPlaces = (location, type = "museum") => {
  const service = new window.google.maps.places.PlacesService(mapRef.current);
  
  const request = {
    location,
    radius: 1000, // meters
    type
  };

  service.nearbySearch(request, (results, status) => {
    if (status === window.google.maps.places.PlacesServiceStatus.OK) {
      setNearbyPlaces(results);
    } else {
      console.error("Places search failed:", status);
    }
  });
};






  // -----------------------------
  //  Fetch Route
  // -----------------------------




  // -----------------------------
  //  Handle Map Translation
  // -----------------------------
  useEffect(() => {
    const retranslateMapCoords = async () => {
      if (!coords.length) return;
  
      const updated = await Promise.all(
        coords.map(async (coord) => {
          const [translatedName, translatedDesc] = await Promise.all([
            translateText(coord.name),
            translateText(coord.description),
          ]);
          return {
            ...coord,
            translatedName,
            translatedDesc,
          };
        })
      );
      
  
      setCoords(updated);
    };
  
    retranslateMapCoords();
  }, [lang]);
  
*/  








  
  

  
  




/*
  // To be checked
  // -----------------------------
  //  Google Maps Helpers
  // -----------------------------
  const getDirection = (site) => {
    const destination = `${site.lat},${site.lon}`;
    const origin = startingAddress ? encodeURIComponent(startingAddress) : "";
    const googleMapsUrl = origin
      ? `https://www.google.com/maps/dir/?api=1&origin=${origin}&destination=${destination}`
      : `https://www.google.com/maps/dir/?api=1&destination=${destination}`;
    window.open(googleMapsUrl, "_blank");
  };

*/






  
  

  if (loading) return <p>{translatedText.text9}</p>;
  if (error) return <p>{translatedText.text10} {error}</p>;
  if (!tour.details.length) return <p>{translatedText.text11}</p>;










  // -----------------------------
  //  JSX Return
  // -----------------------------
  return (
 
    <div>
    <h2 style={{ 
        color: "black",
        display: "flex", 
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        textDecorationColor: "GrayText", 
        fontSize: "40px",
        marginBottom: "20px",
        fontWeight: "bold"
    }}>
        <span>{`${translatedText.text3}${ selectedDayIndex}`}</span>
        <span>{TappaData[`it_tappaname${selectedDayIndex}`] || translatedText.text1}</span>
    </h2>


    {TappaData[`it_Subheadingtappa${selectedDayIndex}`] && (
    <div>
        <h3 style={{ textAlign: "center", color: "black", fontSize: "30px" }}>{TappaData[`it_Subheadingtappa${selectedDayIndex}`]} </h3>
        <div style={{ marginBottom: "20px" }}></div>
    </div>
  )}
  











{/* Galleria part */}
<div style={{
  backgroundColor: "#f5f5f5",
  padding: "5vh 5vw",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  color: "#000000",
}}>
{/*
  <h2 style={{
    color: "#000000",
    alignSelf: "flex-start",
    fontWeight: "bold",
    marginBottom: "7vh",
    fontSize: "1.5rem"

  }}>
    Galleria
  </h2>
*/}














  {tappaimage.length > 0 && (
  <div style={{
    position: "relative",
    width: "100%",
    maxWidth: "80vw",
    aspectRatio: "16 / 9"
  }}>
    <button onClick={() => setCurrentImg(i => (i === 0 ? tappaimage.length - 1 : i - 1))} style={{
      position: "absolute", left: "-6vw", top: "50%",
      width: "3.5vw", height: "3.5vw", fontSize: "4.5rem", fontWeight: "bold",
      backgroundColor: "transparent", border: "none", color: "#324B8E", cursor: "pointer"
    }}>{`<`}</button>

    <img
      src={tappaimage[currentImg]}
      alt="Gallery"
      style={{
        width: "120%", height: "100%",
        objectFit: "contain", borderRadius: "0.5vw"
      }}
    />

    <button onClick={() => setCurrentImg(i => (i === tappaimage.length - 1 ? 0 : i + 1))} style={{
      position: "absolute", right: "-6vw", top: "50%",
      width: "3.5vw", height: "3.5vw", fontSize: "4.5rem", fontWeight: "bold",
      backgroundColor: "transparent", border: "none", color: "#324B8E", cursor: "pointer"
    }}>{`>`}</button>
  </div>
)}

</div>





























      {/* Main Google Map */}
    




{/* Directions panel */}
{/*    <div style={{ display: "flex", height: "80vh", flexDirection: "row", alignItems: "flex-start", justifyContent: "center" }}>
  {showRoute && (
  <div
    style={{
      width: "20%",
      height: "100%", // Match parent height
      //padding: "1rem",
      backgroundColor: "#f5f5f5",
      borderRadius: "10px",
      display: "flex",
      flexDirection: "column",
      overflowY: "auto", // Make scrollable
      boxSizing: "border-box",
      //marginLeft: "5%"
    }}
  >

<select
  onChange={(e) => {
    const value = e.target.value;
    setDirectionsResult(null);

    if (value === "current-location") {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const userLocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          setStartingAddress(userLocation);
        },
        () => {
          alert(translatedText.text25);
        }
      );
    } else {
      const [lat, lng] = value.split(",").map(Number);
      setStartingAddress({ lat, lng });
    }
  }}
  
  defaultValue=""
  style={{
    width: "100%",
    padding: "0.5rem",
    borderRadius: "6px",
    marginBottom: "0.5rem"
  }}
>
  <option value="" disabled>{translatedText.text7_2}</option>
  <option value="current-location">📍 {translatedText.text7_1}</option>
  {coords
    .filter((coord) => coord.day === selectedDayIndex)
    .map((coord, idx) => (
      <option key={idx} value={`${coord.lat},${coord.lon}`}>
        {coord.name}
      </option>
  ))}
</select>


<select
      onChange={(e) => {
        const value = e.target.value;
        setDirectionsResult(null);
        if (value === "current-location") {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              const userLocation = {
                lat: position.coords.latitude,
                lng: position.coords.longitude,
              };
              setDestination(userLocation); 
            },
            (error) => {
              console.warn("Geolocation error:", error.message);
              alert(translatedText.text25 + " (" + error.message + ")");
            }
          );
        } else {
            const [lat, lon] = e.target.value.split(",").map(Number);
            setDestination({ lat, lng: lon });
          }
        }}   
        defaultValue=""
        style={{
          width: "100%",
          padding: "0.5rem",
          borderRadius: "6px",
          marginBottom: "0.5rem"
        }}
    >
      <option value="" disabled>{translatedText.text7_3}</option>
      <option value="current-location">📍 {translatedText.text7_1}</option>
      {coords
        .filter((coord) => coord.day === selectedDayIndex)
        .map((coord, idx) => (
          <option key={idx} value={`${coord.lat},${coord.lon}`}>
            {coord.name}
          </option>
      ))}
    </select>



    <div
      ref={directionsPanelRef}
  id="directionsPanel"
  style={{
    flex: "1",
    overflowY: "auto",
    border: "1px solid #ccc",
    borderRadius: "10px",
    backgroundColor: "#fff",
    padding: "15px",
    fontFamily: "Arial, sans-serif",
    fontSize: "0.95rem",
    lineHeight: "1.6",
    color: "#333"
  }}
>
  {directionsResult?.routes?.[0]?.legs?.map((leg, i) => (
    <div key={i} style={{ marginBottom: "20px" }}>
      <div style={{
        fontWeight: "bold",
        fontSize: "1rem",
        marginBottom: "10px",
        color: "#324B8E"
      }}>
        {leg.start_address} <span style={{ color: "#999" }}>➜</span> {leg.end_address}
      </div>

      <ol style={{ paddingLeft: "1.2rem", margin: 0 }}>
        {leg.steps.map((step, j) => (
          <li
            key={j}
            style={{
              marginBottom: "0.75rem",
              padding: "0.6rem 0.8rem",
              backgroundColor: "#f9f9f9",
              borderRadius: "6px",
              border: "1px solid #eee"
            }}
          >
            <div dangerouslySetInnerHTML={{ __html: step.instructions }} />
            <div style={{ fontSize: "0.85rem", color: "#666", marginTop: "0.3rem" }}>
              🕒 {step.duration.text} — 🛣 {step.distance.text}
            </div>
          </li>
        ))}
      </ol>
    </div>
  ))}
</div>
  </div>
)}
























{/* Map container div 
  <div style={{ position: "relative", width: showRoute ? "80%" : "100%", height: "100%", marginBottom: "12vh" }}>
    {/* Route Toggle Button 
    <button
      onClick={() => setShowRoute(!showRoute)}
      style={{
        width: "30%",
        //maxWidth: "200px",
        position: "absolute",
        top: "2vh",
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 1000,
        padding: "1vh 2vw",
        backgroundColor: showRoute ? "rgba(220, 53, 69, 0.7)" : "rgba(40, 167, 69, 0.7)",
        color: "white",
        border: "none",
        borderRadius: "1vw",
        fontSize: "1.2em",
        cursor: "pointer",
      }}
    >
      {showRoute ? translatedText.text13 : translatedText.text14}
    </button>


















      <GoogleMap
        //center={initialMapCenter}
        onLoad={(map) => {
          mapRef.current = map;

          const selectedCoord = coords.find(c => c.day === selectedDayIndex);
          const bounds = new window.google.maps.LatLngBounds();

        //  if (coords.length) {
        //    const bounds = new window.google.maps.LatLngBounds();
        //    coords.forEach(({ lat, lon }) => bounds.extend({ lat, lng: lon }));
        //    map.fitBounds(bounds);
        //  }


            if (selectedCoord) {
              bounds.extend({ lat: selectedCoord.lat, lng: selectedCoord.lon });
            }

            if (userLocation) {
              bounds.extend({ lat: userLocation.lat, lng: userLocation.lng });
            }

            if (!bounds.isEmpty()) {
              map.fitBounds(bounds);

              // Zoom out one level after fitting
              const listener = window.google.maps.event.addListenerOnce(map, "bounds_changed", () => {
                const currentZoom = map.getZoom();
                if (currentZoom !== undefined && currentZoom !== null) {
                  map.setZoom(currentZoom - 1); // Zoom out one level
                }
              });
            }
        }}
        zoom={8}               // zoom lower number is 3
        mapContainerStyle={{
          width: "90%",
          height: "100%",
          border: "2px solid #ccc",
          borderRadius: "10px",
          margin: "0 auto",         //888 deleted there
        }}
        
        options={{
          minZoom: 4, // to Prevent zooming out too far
          maxZoom: 20,
          mapTypeControl: true,
          fullscreenControl: true,
        }}

      >























  <div style={{
    position: "absolute",
    bottom: "10px",
    left: "50%",
    transform: "translateX(-50%)",
    zIndex: 10
  }}>

  <button
  onClick={() => {
    const tappa = tourInfo.days.find((_, index) => index + 1 === selectedDayIndex);
    if (!tappa || !tappa.tappaGPS) return;
    const [lat, lng] = tappa.tappaGPS.split(",").map(Number);
    
    if (!showAttractions) {
      fetchNearbyPlaces({ lat, lng });
    }
    setShowAttractions(prev => !prev);
  }}
  style={{
    marginBottom: "10px",
    padding: "8px 12px",
    backgroundColor: showAttractions ? "rgba(220, 53, 69, 0.7)" : "rgba(40, 167, 69, 0.7)",  // semi-transparent red or green
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    width: "100%",
    fontWeight: "bold"
  }}
>
  {showAttractions ? translatedText.text31 : translatedText.text32}
</button>
  </div>



        {/* Markers for nearby places 
        {showAttractions &&
  nearbyPlaces.map((place, index) => (
    <Marker
      key={`nearby-mini-${index}`}
      position={{
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng()
      }}
      icon={{
        url: "http://maps.google.com/mapfiles/ms/icons/green-dot.png"
      }}
      title={place.name}
    />
))}






















        {/* 1) Render Markers 
        {coords
          .filter((site) => site.day === selectedDayIndex)
          .map((site) => (
          <Marker
          key={`${site.id}-${site.day}`}
          position={{ lat: site.lat, lng: site.lon }}
          icon={{
            url: "/marker.svg",
//            scaledSize: { width: 30, height: 41 }
            scaledSize: getIconSize()

          }}
          onClick={() => {
            setPopupInfo(site);
//            setHoverInfo(null);
          }}
          label={{
            text: site.name,
            color: "blue",
            fontSize: "0.8vw",
            fontWeight: "bold",
          }}
      
     //     icon={{
     //       url: "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=", // 1x1 transparent gif
    //      }}

        />
        
        ))}
        







        {userLocation && (
  <Marker
    position={userLocation}
    title="Me"
    label={{ text: translatedText.text12, color: "yellow", fontWeight: "bold" }}
    icon={{
      url: "http://maps.google.com/mapfiles/ms/icons/blue-dot.png"
    }}
  />
)}




















                  {/* 3) Popup InfoWindow (on marker click) + Polyline 
                  {popupInfo && (
            
              <InfoWindow
                position={{ lat: popupInfo.lat, lng: popupInfo.lon }}
                onCloseClick={() => setPopupInfo(null)}
              >
                 <div style={{
    maxWidth: "250px",
    maxHeight: "300px",
    overflowY: "auto",
    padding: "10px",
    fontSize: "14px",
    lineHeight: "1.4",
    borderRadius: "8px",
    //boxShadow: "0px 4px 8px rgba(0,0,0,0.2)",
  }}>




<h4 style={{ margin: "5px 0", fontSize: "16px", fontWeight: "bold", textAlign: "center" }}>
  <a> {popupInfo.name} </a>
</h4>







    <p style={{ margin: "10px 0" }}>
      {popupInfo.description.length > 100
        ? popupInfo.description.substring(0, 100) + "..."
        : popupInfo.description}
    </p>
    <button onClick={() => getDirection(popupInfo)} style={{
      backgroundColor: "#324B8E",
      color: "white",
      padding: "5px 10px",
      borderRadius: "5px",
      border: "none",
      cursor: "pointer",
      display: "block",
      margin: "5px auto"
    }}>
                    🧭 {translatedText.text26}
                  </button>
                </div>
              </InfoWindow>









              
            
          )}





























                      {/* Directions logic 
                      {showRoute && directionsRequest && (
        <DirectionsService
        key={JSON.stringify(directionsRequest)} // Force remount on change
        options={directionsRequest}
        callback={(res, status) => {
          if (status === "OK") {
            setDirectionsResult(res);
          } else {
            console.error("Directions request failed:", status);
          }
        }}
      />
      
      )}



























        
      </GoogleMap>





      </div>

      </div>
*/}






























  

  




<div className="w-full bg-[#324B8E] py-6">
{/* Tappa Audio */}
<div
  style={{
    maxWidth: "900px",
    margin: "5vh auto 0 auto",
    padding: "0 20px",
    borderRadius: "12px",
  }}
>

</div>







{/* Tappa Descrizione */}
{tour.tappaDescrizione && (
  <div
    style={{
      width: "80vw",
      margin: "0 auto",
      padding: "2rem 1rem",
      backgroundColor: "#324B8E",
    }}
  >
    <h4
      style={{
        color: "white",
        fontSize: "1.125rem",
        fontWeight: "bold",
        marginBottom: "1rem",
        textAlign: "left",
      }}
    >
      {translatedText.text33 /*item.description  tour.tappaDescrizione*/}
    </h4>

    <div className="w-[100%] mx-auto text-white text-justify leading-relaxed text-[1.125rem] whitespace-pre-line space-y-4 mb-4">
      {tour.tappaDescrizione.replace(/<\/?[^>]+(>|$)/g, "")}
    </div>
      {(tappaAudioUrl || ttsAudioUrl) && (
        <AudioPlayer
          src={tappaAudioUrl || ttsAudioUrl}
          autoPlay={false}
          showSkipControls={false}
          showJumpControls={false}
          customAdditionalControls={[]}
          customVolumeControls={["volume"]}
          layout="horizontal-reverse"
          onPlay={(e) => handlePlay(e.target)}
        />
      )}
  </div>
)}




</div>










      























    




    







{/* Approfondimenti dell’esplorazione */}

<div className="w-[80%] mx-auto">
  {approfCount > 0 && (
  <h4
  style={{
    fontFamily: "Montserrat, sans-serif",
    fontWeight: "bold",
    fontSize: "2.25rem",
    lineHeight: "normal",
    letterSpacing: "0",
    color: "#000000",
    textAlign: "center",
    width: "100%",
    margin: "5rem auto",
  }}
>
  
  {approfondimenti.filter(a => a.tappa === selectedDayIndex).length === 1
//    ? getTranslated("text19")
//    : getTranslated("text2")}
    ? `${translatedText.text19} ${selectedDayIndex}`
    : `${translatedText.text2} `}

</h4>
  )}








    <div>
      {/* Render Tour Approfondimenti */}
  
      {(() => {
  const currentTappa = selectedDayIndex;
  const approfondimentiForCurrentDay = approfondimenti.filter(a => a.tappa === currentTappa);
  const isOpen = openApprofondimento === currentTappa;

  return (
    <div style={{ marginTop: "2rem" }}>
      {approfondimentiForCurrentDay.map((item, idx) => {
        const isItemOpen = openApprofondimento === `${currentTappa}-${idx}`;

        return (
          <div key={idx} style={{ marginBottom: "1rem" }}>
            <button
              onClick={async () => {
                const key = `${currentTappa}-${idx}`;

                if (!isItemOpen && !approfondimentiAudio[key]) {
                  const audioProp = `it_tappa${currentTappa}APPROFONDIMENTO${idx + 1}_audio`;
                  const filePath = TappaData?.[audioProp];

                  if (filePath) {
                    setApprofondimentiAudio(prev => ({ ...prev, [key]: toMediaUrl(filePath) }));
                  } else {
                    const url = await speakWithPolly(item.description);
                    setApprofondimentiAudio(prev => ({ ...prev, [key]: url }));
                  }
                }
                setOpenApprofondimento(isItemOpen ? null : key);
              }}
              style={{
                width: "100%",
                padding: "1rem",
                fontSize: "1.125rem",
                fontWeight: "bold",
                backgroundColor: "#111A33",
                color: "white",
                border: "none",
                borderRadius: "8px",
                cursor: "pointer",
//                marginBottom: "10px",
                position: "relative",
                textAlign: "left",
              }}
            >
              {isItemOpen ? (
                <>
                  {item.title}
                  {TappaData[`it_tappa${selectedDayIndex}SubheadingAPPROFONDIMENTO${idx + 1}`] && (
                    <span style={{ marginLeft: 8, fontWeight: 400, fontSize: "0.9rem", opacity: 0.85 }}>
                      — {TappaData[`it_tappa${selectedDayIndex}SubheadingAPPROFONDIMENTO${idx + 1}`]}
                    </span>
                  )}
                </>
              ) : (
                `${translatedText.text7} ${idx + 1}`
              )}
              

              
              <span style={{
                position: "absolute",
                right: "2%",
                top: "50%",
                transform: "translateY(-50%)",
                fontSize: "1.25rem",
                color: "#ffffff",
                filter: "brightness(1.5)",
                textShadow: "0 0 2px black",
              }}>
                {isItemOpen ? "-" : "+"}
              </span>
            </button>


            {isItemOpen && (
              <div className="w-full mx-auto bg-white text-black text-justify leading-relaxed text-[1.0625rem] whitespace-pre-line  rounded-xl shadow-md px-6 py-8  mb-10">
                                                                                    
                {parseBoldText(decodeHtmlEntities(item.description).replace(/<br\s*\/?>/g, " "))}
              
                {approfondimentiAudio[`${currentTappa}-${idx}`] && (
                  <AudioPlayer
                    src={approfondimentiAudio[`${currentTappa}-${idx}`]}
                    autoPlay={false}
                    showSkipControls={false}
                    showJumpControls={false}
                    customAdditionalControls={[]}
                    customVolumeControls={["volume"]}
                    layout="horizontal-reverse"
                    onPlay={(e) => handlePlay(e.target)}
                  />
                )}



              </div>
            )}
          </div>
        );
      })}
    </div>
  );
})()}





<br />
<br />
<div
  style={{
    display: "flex",
    alignItems: "center",
    margin: "2rem 0",
  }}
>
  {/* PREVIOUS (left) */}
  {selectedDayIndex > 1 && (
    <h4
      style={{
        margin: 0,
        fontSize: "1.25rem",
        fontWeight: "bold",
        color: "#324B8E",
        cursor: "pointer",
      }}
    >
      <span
        onClick={handlePrevEsplorazione}
        role="button"
        tabIndex={0} 
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") handlePrevEsplorazione();
        }}
        style={{
          display: "inline-flex",
          gap: "0.4rem",
          cursor: "pointer",
          userSelect: "none",
          alignItems: "center",
        }}
      >
        <span style={{ display: "inline-block", transform: "scaleX(-1)" }}>➔</span>
        {translatedText.text4} {prevDayIndex}
      </span>
    </h4>
  )}

  {/* NEXT (right) */}
  {selectedDayIndex < totalDays ? (
  <h4
    style={{
      margin: 0,
      marginLeft: "auto", // To push it all the way right
      fontSize: "1.25rem",
      fontWeight: "bold",
      color: "#324B8E",
      cursor: "pointer",
    }}
  >
    <span
      onClick={handleNextEsplorazione}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") handleNextEsplorazione();
      }}
      style={{
        display: "inline-flex",
        gap: "0.4rem",
        cursor: "pointer",
        userSelect: "none",
        alignItems: "center",
      }}
    >
      {translatedText.text5} {nextDayIndex} <span aria-hidden="true">➔</span>
    </span>
  </h4>
  ) : (
      // ---- LAST DAY: show CTA to /choose ----
  <h4
    style={{
      margin: 0,
      marginLeft: "auto",
      fontSize: "1.25rem",
      fontWeight: "bold",
      color: "#324B8E",
      cursor: "pointer",
    }}
  >
    <span
      onClick={handleGoToChoose}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") handleGoToChoose();
      }}
      style={{
        display: "inline-flex",
        gap: "0.4rem",
        cursor: "pointer",
        userSelect: "none",
        alignItems: "center",
      }}
    >
      {translatedText.text34} <span aria-hidden="true">➔</span>
    </span>
  </h4>
)}
</div>






<br />
<br />








    </div>







</div>




    <style>{`
  @media (max-width: 992px) {
    div[style*="calc(33.33%"] {
      flex: 0 1 calc(50% - 20px);
    }
  }

  @media (max-width: 600px) {
    div[style*="calc(33.33%"] {
      flex: 0 1 100%;
    }
  }
`}</style>
     



     </div>

     

  );

};

export default Esplorazione;
